import {createContext, FC, PropsWithChildren, useRef} from 'react'
import { initialPrintContextData, PrintConextType } from './types'
export const PrintContext = createContext<PrintConextType>(initialPrintContextData)
const PrintProvider:FC<PropsWithChildren> = ({children})=>{
    const iframeRef = useRef<HTMLIFrameElement | null>(null)
  return (
    <PrintContext.Provider value={{iframeRef}}>
       <iframe ref={iframeRef} style={{display:"none"}}/>
        {children}
    </PrintContext.Provider>
  )
}

export default PrintProvider
